import Vue from 'vue'

const trackedBill = {
  state: {
    billStatuses: [],
  },

  getters: {
    billStatuses(state) {
      return state.billStatuses
    },
  },

  mutations: {
    billStatuses(state, payload) {
      state.billStatuses = payload
    },
  },

  actions: {
    setBillStatuses(context, payload) {
      context.commit('billStatuses', payload)
    },

    loadBillStatuses(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `TrackedBill/BillStatuses`
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.dispatch('setBillStatuses', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, { root: true })
            reject(err)
          }
        )
      })
    },
  },
}

export default trackedBill
